import { render } from "./form-input.vue?vue&type=template&id=2b923e68&scoped=true"
import script from "./form-input.vue?vue&type=script&lang=js"
export * from "./form-input.vue?vue&type=script&lang=js"

import "./form-input.vue?vue&type=style&index=0&id=2b923e68&scoped=true&lang=css"

import exportComponent from "/home/devbuildsseatshopcom/dev.builds.seatshop.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b923e68"]])

export default __exports__